import React from "react";
import Icon from "components/CommonIcon/Icon";

const supportLinks = () => {
  return {
    en: {
      label: "Reach Us via WhatsApp",
      icon: <Icon name="whatsapp" />,
    },
    zh: {
      label: "Reach us via WeChat",
      icon: <Icon name="weibo" />,
    },
    ja: {
      label: "Reach Us via WhatsApp",
      icon: <Icon name="whatsapp" />,
    },
    ko: {
      label: "Reach Us via WhatsApp",
      icon: <Icon name="whatsapp" />,
    },
  };
};

export default supportLinks;
